"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Covid19Banner = require("./Covid19Banner.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageSrc = 'https://assets.fastly.carvana.io/about-assets/exclamation-icon.png';

var DesktopBanner = _react.default.createElement(_Covid19Banner.DesktopBannerWrapper, null, _react.default.createElement(_Covid19Banner.Image, {
  src: imageSrc
}), _react.default.createElement(_Covid19Banner.TextContent, null, _react.default.createElement("span", {
  className: "is-bold"
}, "COVID-19 information"), "\xA0Touchless delivery/pickup is currently underway in your area.", _react.default.createElement(_Covid19Banner.Link, {
  href: "/touchless-delivery"
}, " Learn More")));

var MobileBanner = _react.default.createElement(_Covid19Banner.MobileBannerWrapper, null, _react.default.createElement(_Covid19Banner.TextContent, null, "Safe, touchless delivery & pickup.", _react.default.createElement(_Covid19Banner.Link, {
  href: "/touchless-delivery"
}, " Learn More >")));

var _ref = _react.default.createElement(_Covid19Banner.Covid19BannerWrapper, {
  "data-qa": "covid-19-banner"
}, MobileBanner, DesktopBanner);

var Covid19Banner = function Covid19Banner() {
  return _ref;
};

var _default = Covid19Banner;
exports.default = _default;
module.exports = exports.default;